import { render, staticRenderFns } from "./shift-view-action.vue?vue&type=template&id=2af41869&scoped=true"
import script from "./shift-view-action.vue?vue&type=script&lang=js"
export * from "./shift-view-action.vue?vue&type=script&lang=js"
import style0 from "./shift-view-action.vue?vue&type=style&index=0&id=2af41869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af41869",
  null
  
)

export default component.exports